import type { PricingTranslation } from './types'

export const pricingTranslationEn: PricingTranslation = {
  title: 'Pricing',
  description: 'Manage Pricing in the system',
  actions: {
    create: 'Create Pricing',
    edit: 'Edit Pricing',
    delete: 'Delete Pricing',
    view: 'View Pricing',
    save: 'Save',
    cancel: 'Cancel',
  },
  form: {
    name: 'Name',
    description: 'Description',
    status: 'Status',
  },
  status: {
    active: 'Active',
    inactive: 'Inactive', 
    pending: 'Pending',
  },
  messages: {
    created: 'Pricing created successfully',
    updated: 'Pricing updated successfully',
    deleted: 'Pricing deleted successfully',
    error: 'An error occurred',
  },
}
